<template lang="pug">
div.wrap-item-object-effect-changer.pt16.overflow-scroll
  div(v-if="['Mesh', 'Group'].includes(targetObject.type)").wrap-outline.wrap-controller.px12
    v-checkbox(v-model="outlined" dark
      @change="onChangeOutlined"
      label="輪郭線" append-icon="mdi-account-outline")
    div(v-if="outlined")
      v-slider(v-model="outline.edgeStrength" @change="updateOutline"
        label="強さ" min="0.01" max="10" step="0.01" dark)
      v-slider(v-model="outline.edgeGlow" @change="updateOutline"
        label="滲み" min="0.0" max="10" step="0.1" dark)
      v-slider(v-model="outline.edgeThickness" @change="updateOutline"
        label="厚み" min="0.01" max="10" step="0.01" dark)
      v-slider(v-model="outline.visibleEdgeColor" @change="updateOutline"
        label="濃さ" min="0.0" max="255" step="1" dark)

  div(v-if="['Sprite'].includes(targetObject.type)").wrap-opacity.wrap-controller.px12
    v-checkbox(v-model="isTransparent" dark
      @change="onChangeIsTransparent"
      label="透明" append-icon="mdi-border-none-variant")
    div(v-if="isTransparent")
      v-slider(v-model="opacity" @change="updateOpacity"
        label="透明度" min="0.01" max="1" step="0.01" dark)

  div(v-if="is3DObjectOrStage").wrap-emissive-changer.px12.pt12
    v-slider(v-model="emissiveColor" @change="updateEmissiveColor"
      label="輝度" :min="0x000000" :max="0xffffff" :step="0xffffff / 15" dark)

  div(v-if="isActor")
    div.wrap-controller.px12
      AtomHairWindChanger(:isPhotoStudio="false" :clock="clock"
        :targetObject="targetObject" :targetObjectDoc="targetObjectDoc"
        @updateHairWind="updateHairWind" @resetHairWind="resetHairWind"
        @updateObjectDoc="updateObjectDoc"
        @deleteObjectDocField="deleteObjectDocField")
    div.wrap-controller.px12.pt16
      div.f.fm.flex-between
        span.label.block.fz14 アウトライン (VRM Outline Material)
        v-icon(size="24px" dark) mdi-account-outline
      v-slider(v-model="vrmOutlineWidth" @change="updateVrmOutlineWidth"
        :min="0" :max="0.005" :step="0.0001" dark)
</template>

<style lang="scss" scoped>
@import "@/scss/_variables.scss";
$asset_main_img_size: 52px;
$header_tab_area_height: 104px;
.wrap-item-object-effect-changer {
  color: $dark_primary_text_color;
  width: 80vw; max-width: $studio_window_max_width;
  max-height: calc(#{$device_height} - (#{$studio_basic_margin} * 2) - #{$header_tab_area_height});
  .wrap-outline {
    // border-bottom: solid 0.8px rgba(255, 255, 255, 0.4);
  }
  .wrap-controller {
    border-bottom: solid 0.8px rgba(255, 255, 255, 0.4);
    .label {
      color: $dark_primary_text_color;
    }
  }
}

.v-input--selection-controls {
  margin-top: 0;
}
</style>

<style lang="scss">
@import "@/scss/_variables.scss";
.wrap-item-object-effect-changer {
  .v-label, label {
    bottom: 1px;
    color: $dark_primary_text_color;
  }
  .v-slider--horizontal {
    margin-left: 2px;
    margin-right: 2px;
  }
}
</style>

<script>
import { createNamespacedHelpers } from 'vuex'
const { mapState: mapStateAuth } = createNamespacedHelpers('auth')
import vrmManager from '@/components/mixin/vrmManager'
import gltfManager from '@/components/mixin/gltfManager'
import AtomHairWindChanger from '@/components/atom/studio/AtomHairWindChanger'

export default {
  mixins: [vrmManager, gltfManager],
  components: {
    AtomHairWindChanger
  },
  props: {
    targetObject: {
      type: Object,
      required: true
    },
    targetAsset: {
      type: Object,
      required: true
    },
    objects: {
      type: Array,
      required: true
    },
    clock: {
      type: Object,
      required: true
    }
  },
  computed: {
    ...mapStateAuth(['uid']),
    isActor () {
      return ['actor'].includes(this.targetAsset.type)
    },
    is3DObjectOrStage () {
      return ['3d_stage', '3d_object'].includes(this.targetAsset.type)
    },
    targetObjectDoc () {
      if (!this.isPhotoStudio) {
        const docId = this.targetObject.userData.docId
        return this.objects.filter(o => o.id === docId)[0]
      } else {
        return null
      }
    }
  },
  watch: {
    targetObject (newTargetObject, oldTargetObject) {
      // targetObjectを切り替えた時に初期化
      if (oldTargetObject &&
        newTargetObject.userData.docId !== oldTargetObject.userData.docId) {
        this.initializeEffectProps()
      }
    },
    isTransparent (newOpacity, oldOpacity) {
      // // targetObjectを切り替えただけの場合は処理しない
      // if (this.preventUpdateOpacityByWatch) {
      //   this.preventUpdateOpacityByWatch = false
      //   return
      // }

      // if (newOpacity === true && oldOpacity === false) {
      //   const object = this.objects
      //     .filter(o => o.id === this.targetObject.userData.docId)[0]
      //   if (!object.opacity) {
      //     this.$emit('addObjectOpacityEffect', {
      //       opacity: this.opacity,
      //       targetObject: this.targetObject,
      //       isLoaded: false
      //     })
      //   }
      // } else if (newOpacity === false && oldOpacity === true) {
      //   this.$emit('removeObjectOpacityEffect', this.targetObject)
      // }
    },
    outlined (newOutlined, oldOutlined) {
      // targetObjectを切り替えただけの場合は処理しない
      // if (this.preventUpdateOutlineByWatch) {
      //   this.preventUpdateOutlineByWatch = false
      //   return
      // }

      // if (newOutlined === true && oldOutlined === false) {
      //   const object = this.objects
      //     .filter(o => o.id === this.targetObject.userData.docId)[0]
      //   if (!object.outline) {
      //     console.log('add outline')
      //     this.$emit('addObjectOutlineEffect', {
      //       outline: this.outline,
      //       targetObject: this.targetObject,
      //       isLoaded: false
      //     })
      //   }
      // } else if (oldOutlined === true && newOutlined === false) {
      //   console.log('remove outline')
      //   this.$emit('removeObjectOutlineEffect', this.targetObject)
      // }
    },
    emissiveColor () {
      this.updateMaterialEmissive({
        object: this.targetObject,
        emissiveColor: this.emissiveColor
      })
    },
    vrmOutlineWidth () {
      const vrm = this.targetObject.userData.vrm
      const delta = this.clock.getDelta()
      this.setOutlineToVRM({
        vrm,
        materials: vrm.materials,
        delta,
        outlineWidth: this.vrmOutlineWidth,
        color: { r: 0, g: 0, b: 0, a: 0 }
      })
    }
  },
  data () {
    return {
      isTransparent: false,
      opacity: 1.0,
      
      outlined: false,
      outline: {},

      emissiveColor: 0x666666,

      vrmOutlineWidth: 0.0015
    }
  },
  created () {
    this.initializeEffectProps()
  },
  methods: {
    initializeEffectProps () {
      const object = this.objects
        .filter(o => o.id === this.targetObject.userData.docId)[0]
      
      // console.log('initializeEffectProps:', object)
      
      // transparent
      if (object.opacity) {
        this.opacity = object.opacity
        this.isTransparent = true
      } else {
        this.isTransparent = false
      }

      // outline
      if (object.outline) {
        this.outline = {
          edgeStrength: object.outline.edgeStrength,
          edgeGlow: object.outline.edgeGlow,
          edgeThickness: object.outline.edgeThickness,
          visibleEdgeColor: object.outline.visibleEdgeColor
        }
        this.outlined = true
      } else {
        this.outline = {
          edgeStrength: 10.0,
          edgeGlow: 0.0,
          edgeThickness: 1.0,
          visibleEdgeColor: 255
        }
        this.outlined = false
      }

      if (object.emissiveColor) {
        this.emissiveColor = object.emissiveColor
      } else {
        this.emissiveColor = 0x666666
      }

      if (object.vrmOutlineWidth) {
        this.vrmOutlineWidth = object.vrmOutlineWidth
      } else {
        this.vrmOutlineWidth = 0.0015
      }
    },
    updateOpacity () {
      this.$emit('updateObjectOpacityEffect', {
        opacity: this.opacity,
        targetObject: this.targetObject
      })
    },
    updateOutline () {
      this.$emit('updateObjectOutlineEffect', {
        outline: this.outline,
        targetObject: this.targetObject
      })
    },
    onChangeIsTransparent () {
      if (this.isTransparent) {
        const object = this.objects
          .filter(o => o.id === this.targetObject.userData.docId)[0]
        if (!object.opacity) {
          this.$emit('addObjectOpacityEffect', {
            opacity: this.opacity,
            targetObject: this.targetObject,
            isLoaded: false
          })
        }
      } else {
        this.$emit('removeObjectOpacityEffect', this.targetObject)
      }
    },
    onChangeOutlined () {
      if (this.outlined) {
        const object = this.objects
          .filter(o => o.id === this.targetObject.userData.docId)[0]
        if (!object.outline) {
          // console.log('add outline')
          this.$emit('addObjectOutlineEffect', {
            outline: this.outline,
            targetObject: this.targetObject,
            isLoaded: false
          })
        }
      } else {
        // console.log('remove outline')
        this.outline = {
          edgeStrength: 3.0,
          edgeGlow: 1.0,
          edgeThickness: 1.0,
          visibleEdgeColor: 255
        }
        this.$emit('removeObjectOutlineEffect', this.targetObject)
      }
    },
    updateEmissiveColor () {
      this.$emit('updateEmissiveColor', {
        targetObject: this.targetObject,
        emissiveColor: this.emissiveColor
      })
    },
    updateVrmOutlineWidth () {
      this.$emit('updateVrmOutlineWidth', {
        targetObject: this.targetObject,
        vrmOutlineWidth: this.vrmOutlineWidth
      })
    },
    // Hair Wind
    updateHairWind ({ vrm, delta, params }) {
      this.$emit('updateHairWind', { vrm, delta, params })
    },
    resetHairWind ({ vrm, delta }) {
      this.$emit('resetHairWind', { vrm, delta })
    },
    // common
    updateObjectDoc (params) {
      this.$emit('updateObjectDoc', params)
    },
    deleteObjectDocField (params) {
      this.$emit('deleteObjectDocField', params)
    }
  }
}
</script>
